import cn from "classnames";
import type { ComponentProps, FC } from "react";
import { Loader } from "../common/Loader";
import styles from "./ContentLoading.module.css";

type Props = ComponentProps<"div"> & {
	label?: string;
};

export const ContentLoading: FC<Readonly<Props>> = ({
	className,
	label,
	...rest
}) => {
	return (
		<div className={cn(styles.container, className)} {...rest}>
			<Loader size="lg" label={label} block />
		</div>
	);
};
